import React, { useRef } from "react";
import PropTypes from "prop-types";
import { Box, Typography, Grid, Divider, Chip, Paper } from "@mui/material";
import { Print } from "@mui/icons-material";
import QRCode from "qrcode.react";
import MDButton from "shared/components/MDButton";

const EMPRESA_DATA = {
  nombre: "ISERRA 100",
  razonSocial: "CENTRO COMERCIAL ISERRA 100 PH",
  nit: "830.019.348-2",
  idMaquina: "ISERRA 100",
  slogan: "CENTRO COMERCIAL",
  descripcion: "Control de Bicicletas",
};

const TicketContent = React.forwardRef(({ data, qrValue, numeroRegistro }, ref) => {
  const fecha = new Date().toLocaleString("es-CO", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  return (
    <Box
      ref={ref}
      id="ticket-content"
      sx={{
        width: 380,
        maxWidth: "100%",
        mx: "auto",
        bgcolor: "#ffffff",
        fontFamily: "'Courier New', monospace",
        border: "2px solid #000",
        borderRadius: 2,
        boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        p: 0,
        overflow: "hidden",
      }}
    >
      <Box sx={{ p: 3 }}>
        <Box sx={{ textAlign: "center", mb: 2 }}>
          <Typography
            variant="h4"
            fontWeight="bold"
            sx={{
              color: "#1a237e",
              letterSpacing: 3,
              fontSize: "1.5rem",
              fontFamily: "'Courier New', monospace",
            }}
          >
            {EMPRESA_DATA.nombre}
          </Typography>
          <Typography
            variant="caption"
            display="block"
            sx={{
              color: "#555",
              fontSize: "0.75rem",
              letterSpacing: 2,
              fontWeight: "bold",
            }}
          >
            {EMPRESA_DATA.slogan}
          </Typography>
          <Typography
            variant="caption"
            display="block"
            sx={{
              color: "#555",
              fontSize: "0.7rem",
              letterSpacing: 0.5,
            }}
          >
            {EMPRESA_DATA.descripcion}
          </Typography>
          <Divider sx={{ my: 1.5, borderColor: "#1a237e", borderWidth: 2 }} />
        </Box>

        <Box sx={{ mb: 2, fontSize: "0.65rem" }}>
          <Grid container spacing={0.5}>
            <Grid item xs={12}>
              <Box display="flex" justifyContent="space-between">
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontWeight: "bold", fontSize: "0.6rem" }}
                >
                  RAZON SOCIAL:
                </Typography>
                <Typography
                  variant="caption"
                  sx={{ fontSize: "0.6rem", textAlign: "right", fontWeight: "bold" }}
                >
                  {EMPRESA_DATA.razonSocial}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box display="flex" justifyContent="space-between">
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontWeight: "bold", fontSize: "0.6rem" }}
                >
                  NIT:
                </Typography>
                <Typography variant="caption" sx={{ fontSize: "0.6rem", fontWeight: "bold" }}>
                  {EMPRESA_DATA.nit}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box display="flex" justifyContent="space-between">
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontWeight: "bold", fontSize: "0.6rem" }}
                >
                  #ID MAQUINA:
                </Typography>
                <Typography variant="caption" sx={{ fontSize: "0.6rem", fontWeight: "bold" }}>
                  {EMPRESA_DATA.idMaquina}
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <Divider sx={{ my: 1.5 }} />
        </Box>

        <Box sx={{ textAlign: "center", mb: 2 }}>
          <Typography
            variant="h5"
            fontWeight="bold"
            sx={{
              color: data.modo === "INGRESO" ? "#2e7d32" : "#c62828",
              letterSpacing: 3,
              fontSize: "1.3rem",
            }}
          >
            {data.modo === "INGRESO" ? "INGRESO" : "SALIDA"}
          </Typography>
          <Typography
            variant="caption"
            display="block"
            sx={{
              fontSize: "0.7rem",
              fontWeight: "bold",
              color: "#333",
              letterSpacing: 1,
            }}
          >
            REGISTRO #{String(numeroRegistro).padStart(6, "0")}
          </Typography>
          <Typography
            variant="caption"
            display="block"
            sx={{
              fontSize: "0.65rem",
              color: "#666",
            }}
          >
            {fecha}
          </Typography>
        </Box>

        <Box
          sx={{
            textAlign: "center",
            my: 2,
            py: 1.5,
            bgcolor: "#fafafa",
            borderRadius: 1,
            border: "1px dashed #ccc",
          }}
        >
          <Box sx={{ display: "inline-block" }}>
            <QRCode value={qrValue} size={130} level="H" includeMargin />
          </Box>
          <Typography
            variant="caption"
            display="block"
            sx={{
              color: "#666",
              mt: 0.5,
              fontSize: "0.6rem",
            }}
          >
            Escanea para ver los detalles
          </Typography>
        </Box>

        <Box sx={{ mb: 1.5 }}>
          <Typography
            variant="caption"
            fontWeight="bold"
            sx={{
              color: "#1a237e",
              fontSize: "0.75rem",
              letterSpacing: 1,
              display: "block",
              textAlign: "center",
              mb: 0.5,
            }}
          >
            DATOS DEL USUARIO
          </Typography>
          <Divider sx={{ my: 0.5 }} />
          <Grid container spacing={0.5} sx={{ fontSize: "0.7rem" }}>
            <Grid item xs={4}>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ fontSize: "0.65rem", fontWeight: "bold" }}
              >
                Nombre:
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="caption" fontWeight="bold" sx={{ fontSize: "0.7rem" }}>
                {data.nombreCompleto || "—"}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ fontSize: "0.65rem", fontWeight: "bold" }}
              >
                Cédula:
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="caption" sx={{ fontSize: "0.7rem" }}>
                {data.cedula || "—"}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ fontSize: "0.65rem", fontWeight: "bold" }}
              >
                Celular:
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="caption" sx={{ fontSize: "0.7rem" }}>
                {data.celular || "—"}
              </Typography>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ mb: 1.5 }}>
          <Typography
            variant="caption"
            fontWeight="bold"
            sx={{
              color: "#1a237e",
              fontSize: "0.75rem",
              letterSpacing: 1,
              display: "block",
              textAlign: "center",
              mb: 0.5,
            }}
          >
            DATOS DE LA BICICLETA
          </Typography>
          <Divider sx={{ my: 0.5 }} />
          <Grid container spacing={0.5} sx={{ fontSize: "0.7rem" }}>
            <Grid item xs={4}>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ fontSize: "0.65rem", fontWeight: "bold" }}
              >
                Marca:
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="caption" fontWeight="bold" sx={{ fontSize: "0.7rem" }}>
                {data.marca || "—"}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ fontSize: "0.65rem", fontWeight: "bold" }}
              >
                Color:
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Box display="flex" alignItems="center" gap={1}>
                <Box
                  sx={{
                    width: 12,
                    height: 12,
                    borderRadius: "50%",
                    bgcolor: data.color ? data.color.toLowerCase() : "#e0e0e0",
                    border: "1px solid #ccc",
                    flexShrink: 0,
                  }}
                />
                <Typography variant="caption" sx={{ fontSize: "0.7rem" }}>
                  {data.color || "—"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ fontSize: "0.65rem", fontWeight: "bold" }}
              >
                Serie:
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="caption" sx={{ fontSize: "0.7rem" }}>
                {data.serie || "—"}
              </Typography>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ mb: 1.5 }}>
          <Typography
            variant="caption"
            fontWeight="bold"
            sx={{
              color: "#1a237e",
              fontSize: "0.75rem",
              letterSpacing: 1,
              display: "block",
              textAlign: "center",
              mb: 0.5,
            }}
          >
            GANCHO
          </Typography>
          <Divider sx={{ my: 0.5 }} />
          <Grid container spacing={0.5} sx={{ fontSize: "0.7rem" }}>
            <Grid item xs={4}>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ fontSize: "0.65rem", fontWeight: "bold" }}
              >
                Número:
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="caption" fontWeight="bold" sx={{ fontSize: "0.7rem" }}>
                #{String(data.gancho || "").padStart(2, "0")}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ fontSize: "0.65rem", fontWeight: "bold" }}
              >
                Estado:
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Chip
                size="small"
                label={data.modo === "INGRESO" ? "OCUPADO" : "DISPONIBLE"}
                sx={{
                  height: 20,
                  fontSize: "0.6rem",
                  fontWeight: "bold",
                  bgcolor: data.modo === "INGRESO" ? "#ffebee" : "#e8f5e9",
                  color: data.modo === "INGRESO" ? "#c62828" : "#2e7d32",
                }}
              />
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ mb: 1.5 }}>
          <Typography
            variant="caption"
            fontWeight="bold"
            sx={{
              color: "#1a237e",
              fontSize: "0.75rem",
              letterSpacing: 1,
              display: "block",
              textAlign: "center",
              mb: 0.5,
            }}
          >
            FOTOS TOMADAS
          </Typography>
          <Divider sx={{ my: 0.5 }} />
          <Grid container spacing={0.5} sx={{ fontSize: "0.7rem" }}>
            <Grid item xs={4}>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ fontSize: "0.65rem", fontWeight: "bold" }}
              >
                Estado:
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Box display="flex" gap={0.5} flexWrap="wrap">
                {data.fotos?.cedula && (
                  <Chip
                    size="small"
                    label="✓ Cédula"
                    sx={{ height: 18, fontSize: "0.5rem", bgcolor: "#e8f5e9", color: "#2e7d32" }}
                  />
                )}
                {data.fotos?.bicicleta && (
                  <Chip
                    size="small"
                    label="✓ Bicicleta"
                    sx={{ height: 18, fontSize: "0.5rem", bgcolor: "#e8f5e9", color: "#2e7d32" }}
                  />
                )}
                {data.fotos?.usuario && (
                  <Chip
                    size="small"
                    label="✓ Usuario"
                    sx={{ height: 18, fontSize: "0.5rem", bgcolor: "#e8f5e9", color: "#2e7d32" }}
                  />
                )}
                {!data.fotos?.cedula && !data.fotos?.bicicleta && !data.fotos?.usuario && (
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.6rem" }}>
                    Sin fotos
                  </Typography>
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ textAlign: "center", mt: 2, pt: 2, borderTop: "2px solid #000" }}>
          <Typography
            variant="caption"
            sx={{
              color: "#1a237e",
              fontWeight: "bold",
              fontSize: "0.7rem",
              letterSpacing: 0.5,
            }}
          >
            ¡Gracias por usar nuestro servicio!
          </Typography>
          <Typography
            variant="caption"
            display="block"
            color="text.secondary"
            sx={{ fontSize: "0.55rem", mt: 0.5 }}
          >
            Este recibo es válido para retirar la bicicleta.
          </Typography>
          <Typography
            variant="caption"
            display="block"
            color="text.secondary"
            sx={{ fontSize: "0.55rem" }}
          >
            Presenta este recibo en la entrada.
          </Typography>
          <Divider sx={{ my: 1, borderColor: "#1a237e", borderWidth: 1 }} />
          <Typography
            variant="caption"
            display="block"
            sx={{
              color: "#64748b",
              fontSize: "0.5rem",
              letterSpacing: 1,
            }}
          >
            {EMPRESA_DATA.nombre} - {EMPRESA_DATA.idMaquina}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
});

TicketContent.displayName = "TicketContent";

TicketContent.propTypes = {
  data: PropTypes.shape({
    nombreCompleto: PropTypes.string,
    cedula: PropTypes.string,
    celular: PropTypes.string,
    marca: PropTypes.string,
    color: PropTypes.string,
    serie: PropTypes.string,
    gancho: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    modo: PropTypes.string,
    fotos: PropTypes.shape({
      cedula: PropTypes.bool,
      bicicleta: PropTypes.bool,
      usuario: PropTypes.bool,
    }),
  }).isRequired,
  qrValue: PropTypes.string.isRequired,
  numeroRegistro: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

const TicketPrinter = ({ data, qrValue, numeroRegistro, onClose, hideActions = false }) => {
  const printRef = useRef();

  const handlePrint = () => {
    const printContent = printRef.current;
    if (!printContent) return;

    const printWindow = window.open("", "_blank", "width=420,height=750");

    if (printWindow) {
      const htmlContent = `
        <!DOCTYPE html>
        <html>
          <head>
            <title>Ticket - ISERRA 100</title>
            <meta charset="UTF-8">
            <style>
              * { margin: 0; padding: 0; box-sizing: border-box; }
              body {
                font-family: 'Courier New', monospace;
                background: #fff;
                padding: 0;
                margin: 0;
              }
              @media print {
                @page {
                  margin: 0;
                  size: 80mm auto;
                }
                body { width: 80mm; }
              }
              img { max-width: 100%; display: block; }
            </style>
          </head>
          <body>
            ${printContent.innerHTML}
            <script>
              window.onload = function() {
                setTimeout(function() {
                  window.print();
                  setTimeout(function() { window.close(); }, 500);
                }, 300);
              };
            <\/script>
          </body>
        </html>
      `;
      printWindow.document.write(htmlContent);
      printWindow.document.close();
    }
  };

  return (
    <Paper
      sx={{
        p: 3,
        borderRadius: 3,
        boxShadow: hideActions ? "none" : "0 8px 32px rgba(0,0,0,0.12)",
        maxWidth: 420,
        mx: "auto",
        border: hideActions ? "none" : undefined,
      }}
    >
      {!hideActions && (
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h6" fontWeight="bold" sx={{ color: "#1a237e" }}>
            <Print sx={{ mr: 1, verticalAlign: "middle" }} />
            Ticket de Registro
          </Typography>
          <MDButton variant="outlined" onClick={onClose} size="small" sx={{ borderRadius: 1 }}>
            Cerrar
          </MDButton>
        </Box>
      )}

      <TicketContent ref={printRef} data={data} qrValue={qrValue} numeroRegistro={numeroRegistro} />

      {!hideActions && (
        <Box mt={2} display="flex" justifyContent="center">
          <MDButton
            variant="contained"
            onClick={handlePrint}
            startIcon={<Print />}
            sx={{
              px: 4,
              py: 1.5,
              borderRadius: 2,
              fontWeight: "bold",
              bgcolor: "#1a237e",
              color: "#ffffff !important",
              "&:hover": { bgcolor: "#0d1445" },
            }}
          >
            🖨️ Imprimir Ticket
          </MDButton>
        </Box>
      )}
    </Paper>
  );
};

TicketPrinter.propTypes = {
  data: PropTypes.shape({
    nombreCompleto: PropTypes.string,
    cedula: PropTypes.string,
    celular: PropTypes.string,
    marca: PropTypes.string,
    color: PropTypes.string,
    serie: PropTypes.string,
    gancho: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    modo: PropTypes.string,
    fotos: PropTypes.shape({
      cedula: PropTypes.bool,
      bicicleta: PropTypes.bool,
      usuario: PropTypes.bool,
    }),
  }).isRequired,
  qrValue: PropTypes.string.isRequired,
  numeroRegistro: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onClose: PropTypes.func,
  hideActions: PropTypes.bool,
};

TicketPrinter.defaultProps = {
  onClose: null,
  hideActions: false,
};

export default TicketPrinter;
